import { CommonModule } from '@angular/common';
import { Component, OnInit, SecurityContext, NgZone, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { directus, Edizione, Iscrizione, Progetto } from '../../../../directus';
import { readItem, readItems, updateItem, deleteItem } from '@directus/sdk';
import { BaseComponent } from '../base/base.component';
import { AppComponent } from '../../app.component';
import { EdizioneObj } from '../../classes/edizione-obj';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { QRCodeModule } from 'angularx-qrcode';

import { environment } from '../../../environments/environment';
import { CanvasBadgeComponent } from '../canvas-badge/canvas-badge.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEye, faEnvelope, faPrint, faCheck, faSearch, faPencil, faUser, faUsers, faFileExcel, faVideo } from '@fortawesome/free-solid-svg-icons';
import { IscrizioneObj } from '../../classes/iscrizione-obj';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';

/*EXCEL*/
import { ExcelService } from '../../services/excel.service';

@Component({
  selector: 'app-edizione',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, FontAwesomeModule, QRCodeModule, CanvasBadgeComponent, HttpClientModule],
  templateUrl: './edizione.component.html',
  styleUrl: './edizione.component.css'
})
export class EdizioneComponent extends BaseComponent implements OnInit {
  edizione: EdizioneObj | undefined;
  progetto: Progetto | undefined;
  iscritti: IscrizioneObj[] | undefined;

  iscritto: IscrizioneObj | undefined;
  confermati: number = 0;
  presenti: number = 0;
  iscrizioni: number = 0;

  submitted = false;
  sanitizedValue: string = '';

  @ViewChild(CanvasBadgeComponent)
  badge_component!: CanvasBadgeComponent;

  faEye: any;
  faEnvelope: any;
  faPrint: any;
  faCheck: any
  faSearch: any;
  faPencil: any;
  faUser: any;
  faUsers: any;
  faFileExcel: any;
  faVideo: any;

  http: HttpClient | undefined;
  app: AppComponent;

  @Input() searchText: string = '';
  filtroConfermati: boolean = false;
  filtroPresenti: boolean = false;

  searchTimer: any;

  constructor(protected override router: Router, private route: ActivatedRoute, private _app: AppComponent, private readonly _formBuilder: FormBuilder, private sanitizer: DomSanitizer, public zone: NgZone, _http: HttpClient, private chRef: ChangeDetectorRef, private excelService: ExcelService) {
    super(router);
    this.layoutGrid = true;

    this.faEye = faEye;
    this.faEnvelope = faEnvelope;
    this.faPrint = faPrint;
    this.faCheck = faCheck;
    this.faSearch = faSearch;
    this.faPencil = faPencil;
    this.faUser = faUser;
    this.faUsers = faUsers;
    this.faFileExcel = faFileExcel;
    this.faVideo = faVideo;

    this.http = _http;
    this.app = _app;
  }



  async ngOnInit(): Promise<void> {
    if (this.route.snapshot.paramMap.get('id')) {
      const _id = this.route.snapshot.paramMap.get('id');
      if (_id) {
        const __id = _id as unknown as number;
        await this.getEdizioneById(__id);
        if (this.edizione && this.edizione != undefined) {
          const _idEd = Number(this.edizione.id);
          await this.getAllIscrizioni(_idEd, null);
          await this.getProgettoById(this.edizione.progetto);
          if (this.progetto?.colore) {
            this._bgColor = this.getBackgroundAlpha(this.progetto?.colore);
          }
        }

        this.initFormIscrizione();

      } else {
        alert(' Edizione non trovata!');
      }
    }
  }

  /*
  PROGETTO
  */
  async getProgettoById(id: number) {
    this.progetto = await directus
      .request<Progetto>(readItem('progetti', id));
  }

  /*
  EDIZIONE
  */
  async getEdizioneById(id: number) {
    const _ed: Edizione = await directus
      .request<Edizione>(readItem('edizione', id));

    this.edizione = new EdizioneObj(_ed);
  }
  /*
  PRESENZE
  */
  presenza() {
    const url = this.router.createUrlTree(['/presenza', this.edizione?.id])
    window.open(url.toString(), '_blank')
  }
  presenze() {
    const url = this.router.createUrlTree(['/presenze', this.edizione?.id])
    window.open(url.toString(), '_blank')
  }
  /*
  ISCRIZIONI
  */
  filtroConf() {
    this.filtroConfermati = !this.filtroConfermati;
    this.search(this);
  }
  filtroPres() {
    this.filtroPresenti = !this.filtroPresenti;
    this.search(this);
  }
  searchKey() {
    //console.log('SEARCHKEY ' + this.searchText);
    const self = this;
    if ((this.searchTimer as unknown as number) % 2 === 0) {
      clearTimeout(self.searchTimer);
    }
    if (this.searchText && this.searchText.length >= 3) {
      this.searchTimer = setTimeout(self.search, 2000, self);
    }
  }
  search(_this: any) {
    /*
    this.filtered_iscritti = this.iscritti.filter((element)=>{
      if( element.nome.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0){
        return true;
      }
      return false;
    });
    */
    let _and: any = [];
    let _or: any = [];
    let _isOR = 0;
    const filter: any = {
      "edizione": {
        "_eq": _this.edizione?.id
      }, "_and": []
    };
    const filterOr: any = {
      "edizione": {
        "_eq": _this.edizione?.id,
      },
      "_or": [],
    };
    const _confermata = {
      "confermata": {
        "_eq": 1
      }
    };
    const _presenza = {
      "presenza": {
        "_eq": 1
      }
    };

    if (_this.searchText && _this.searchText.length >= 3) {
      let _filter: any;
      _isOR++;

      if (_this.filtroConfermati) {

        filterOr._or.push(_confermata);
      }
      if (_this.filtroPresenti) {
        filterOr._or.push(_presenza);
      }
      if (_isOR > 0) {
        filterOr._or.push(
          {
            "nome": {
              "_icontains": _this.searchText
            }
          }
        );
        filterOr._or.push(
          {
            "cognome": {
              "_icontains": _this.searchText
            }
          }
        );
        filterOr._or.push(
          {
            "azienda": {
              "_icontains": _this.searchText
            }
          }
        );
        _filter = filterOr;
      }

      if (_this.edizione)
        _this.getAllIscrizioni(_this.edizione.id, _filter);

    } else if (_this.filtroConfermati || _this.filtroPresenti) {
      let _filter: any;

      if (_this.filtroConfermati) {

        _isOR++;
        filter._and.push(_confermata);
        _filter = filter;
      }
      if (_this.filtroPresenti) {
        if (_isOR > 0) {
          filterOr._or.push(_confermata);
          filterOr._or.push(_presenza);
          _filter = filterOr;
        } else {
          filter._and.push(_presenza);
          _filter = filter;
        }
      }

      if (_this.edizione)
        _this.getAllIscrizioni(_this.edizione.id, _filter);
    } else {
      if (_this.edizione)
        _this.getAllIscrizioni(_this.edizione.id, null);
    }

  }

  isIscritto(): boolean {
    if (this.iscritto && this.iscritto.id > 0) {
      return true;
    }
    return false;
  }
  setIscrittoToBadge(_iscritto: IscrizioneObj) {
    if (_iscritto) {
      this.badge_component.setBadgeText(_iscritto.nome + ' ' + _iscritto.cognome + '\n' + _iscritto.azienda + (_iscritto.profilo ? ('\n' + _iscritto.profilo) : ''));
      //this.badge_component.setBadgeURL(environment.apiUrl + environment.presence_subscription_route + '/' + _iscritto.id);
      this.badge_component.setBadgeURL(String(_iscritto.id));
      this.badge_component.reinitBage();
      this.badge_component.openModal();
    }
  }
  openIscrizione(_iscritto: IscrizioneObj) {
    if (_iscritto) {
      this.iscritto = _iscritto;

      this.openModal();
      //this.router.navigate(['/iscrizioni', id]);
    };
  }
  async getIscrizioneById(id: number) {
    const _r = await directus
      .request<Iscrizione>(readItem('iscrizioni', id));
    return new IscrizioneObj(_r);
  }
  async deleteIscritto(_iscritto: IscrizioneObj) {
    if (confirm('Eliminare ' + _iscritto.nome + ' ' + _iscritto.cognome + ' ?')) {
      //alert('delete ' + _iscritto.nome);
      const result = await directus.request(deleteItem('iscrizioni', _iscritto.id));
      let index = this.iscritti?.findIndex(d => d.id === _iscritto.id); //find index in your array
      if (index != undefined && index != null && index >= 0)
        this.iscritti?.splice(index, 1)
    }
  }
  async getAllIscrizioni(_id: number, _filter: any = null) {
    const self = this;
    let _anal = false;
    if (_filter == null)
      _anal = true;

    try {
      if (_filter == null) {
        _filter = {
          "edizione": {
            "_eq": _id
          }
        };
      }

      self.app.showSpinner();
      this.iscritti = await directus
        .request<IscrizioneObj[]>(readItems("iscrizioni", {
          filter: _filter,
          limit: -1,
          fields: ["id", "status", "nome", "cognome", "azienda", "email", "edizione", "profilo", "confermata", "presenza", "orario", "date_created", "date_updated"],
          sort: ['date_created'], //Sort by sort field and creation date descending
        }));
      self.app.hideSpinner();
      if (_anal)
        self.analizzaIscrizioni();
    } catch (error: any) {
      error = JSON.parse(JSON.stringify(error));
      if (error && error != undefined) {
        if (error.errors[0].extensions.code === 'FORBIDDEN') {
          //self.app.logOut();
        }
      }
      console.error(error);
      self.app.hideSpinner();
    }
  }
  analizzaIscrizioni() {
    if (!this.iscritti || this.iscritti == undefined)
      return;
    let self = this;
    this.iscrizioni = this.iscritti.length;

    this.iscritti.forEach(async (_iscritto: IscrizioneObj) => {
      if (_iscritto && _iscritto != undefined) {
        self.zone.run(async () => {
          if (_iscritto.confermata == 1) {
            self.confermati++;
          }
          if (_iscritto.presenza == 1) {
            self.presenti++;
          }
        });
      }
    });
  }
  trackIscr(index: any, _sub: any) {
    //console.log(_sub.confermata);
  }
  /*Registra presenza*/
  async confermaPresenza(_iscritto: IscrizioneObj) {
    let _text = 'Confermare la presenza all\'evento di \'' + _iscritto.nome + ' ' + _iscritto.cognome + ' ?';

    if (confirm(_text)) {
      try {
        const self = this;
        const _i = _iscritto as IscrizioneObj;

        if (_i) {

          const _sub: IscrizioneObj = await this.getIscrizioneById(_i.id);

          const result = await directus
            .request<Iscrizione>(updateItem('iscrizioni', _i.id, { presenza: 1 }));

          let index = this.iscritti?.findIndex(d => d.id === _i.id); //find index in your array
          if (index != undefined && index != null && index >= 0 && this.iscritti)
            this.iscritti[index].presenza = 1;

          if (result) {
            alert('Presenza registrata');
          } else {
            alert('Problema riscontrato nella registrazione della presenza');
          }
        }
        self.chRef.detectChanges();

      } catch (error: any) {
        error = JSON.parse(JSON.stringify(error));
        console.error(error);
        this.print_error = error;
      }
    }
  }
  /*INVIO BADGE*/
  confermaIscrizione(_iscritto: IscrizioneObj) {
    let _text = 'Confermare l\'iscrizione di \'' + _iscritto.nome + ' ' + _iscritto.cognome + '\' ed inviare il badge?';
    if (_iscritto.confermata == 1)
      _text = 'Inviare nuovamente il badge a \'' + _iscritto.nome + ' ' + _iscritto.cognome + '\'?';

    if (confirm(_text)) {
      try {
        const self = this;
        const _i = _iscritto as IscrizioneObj;

        if (_i) {

          if (this.http && this.http != undefined) {
            const self = this;
            self.app.showSpinner();

            const url = environment.apiUrl + environment.confirm_subscription_route;


            const transferObject = {
              "id": _i.id
            }

            const header = new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${environment.sub_apy_key}`
            })

            const object = JSON.stringify(transferObject);

            //Here is the point!
            self.http?.post(url, object, { headers: header }).subscribe((response: any) => {
              if (response && response.message === 'fatto') {
                alert('Conferma iscrizione ed invio badge effettuati');
              } else {
                alert('Problemi con la conferma della iscrizione ' + (response.message ? response.message : ''));
              }
              self.app.hideSpinner();
              this.closeModal();
            });

          } else {
            console.error('Httpclient non disponibile!!!');
            self.app.hideSpinner();
          }
          //this.closeModal();
        }

      } catch (error: any) {
        error = JSON.parse(JSON.stringify(error));
        console.error(error);
        this.print_error = error;
      }
    }
  }
  /*STAMPA BADGE*/
  stampaBadges() {
    // alert('stampaBadgeS ');
    if (this.edizione) {
      //this.router.navigate(['/stampabadges', this.edizione.id]);
      const url = this.router.createUrlTree(['/stampabadges', this.edizione.id])
      window.open(url.toString(), '_blank')
    } else {
      alert("Errore: edizione non trovata")
    }
  }
  stampaBadge(_iscritto: IscrizioneObj) {
    //alert('stampaBadge' + _iscritto.nome);
    if (this.edizione && _iscritto) {
      //this.router.navigate(['/stampabadges', this.edizione.id]);
      const url = this.router.createUrlTree(['/stampabadges', this.edizione.id, 'iscrizioneId', _iscritto.id]);
      //alert('stampaBadge ' + url);
      window.open(url.toString(), '_blank')
    } else {
      alert("Errore: edizione o iscrizione non trovata")
    }
  }
  /*
  FORM ISCRIZIONE
  */
  initFormIscrizione() {
    this.form = this._formBuilder.group({
      nome: [(this.iscritto ? this.iscritto.nome : ''), Validators.required],
      cognome: [(this.iscritto ? this.iscritto.cognome : ''), Validators.required],
      azienda: [(this.iscritto ? this.iscritto.azienda : ''), Validators.required],
      email: [(this.iscritto ? this.iscritto.email : ''), [Validators.required, Validators.email]],
      profilo: [(this.iscritto ? this.iscritto.profilo : '')],
    });

    this.form.valueChanges.subscribe((value) => {
      if (value && value != undefined) {
        this.sanitizeInput(value);
      }
    });

  }
  setFormIscrizione() {
    if (this.iscritto && this.iscritto != undefined && this.iscritto.id > 0) {
      this.form.controls['nome'].reset({ value: (this.iscritto ? this.iscritto.nome : ''), disabled: false });
      this.form.controls['cognome'].reset({ value: (this.iscritto ? this.iscritto.cognome : ''), disabled: false });
      this.form.controls['email'].reset({ value: (this.iscritto ? this.iscritto.email : ''), disabled: false });
      this.form.controls['azienda'].reset({ value: (this.iscritto ? this.iscritto.azienda : ''), disabled: false });
      this.form.controls['profilo'].reset({ value: (this.iscritto ? this.iscritto.profilo : ''), disabled: false });
      //this.form.controls['nome'].disable({ onlySelf: true });
    } else {
      this.form.controls['nome'].reset({ value: '', disabled: false });
      this.form.controls['cognome'].reset({ value: '', disabled: false });
      this.form.controls['email'].reset({ value: '', disabled: false });
      this.form.controls['azienda'].reset({ value: '', disabled: false });
      this.form.controls['profilo'].reset({ value: '', disabled: false });
    }
  }
  /*SALVA ISCRITTO<*/

  async onSubmit() {
    try {

      if (this.form.valid) {

        const { nome, cognome, azienda, email, profilo } = this.form.value;

        if (this.iscritto && this.iscritto.id > 0) {
          this.submitted = true;

          this.iscritto.nome = nome;
          this.iscritto.cognome = cognome;
          this.iscritto.azienda = azienda;
          this.iscritto.email = email;
          this.iscritto.profilo = profilo;

          const result = await directus
            .request<Iscrizione>(updateItem('iscrizioni', this.iscritto.id, this.iscritto));

          if (this.iscritti && result)
            Object.assign(this.iscritti[this.iscritti.findIndex(el => el.id === this.iscritto?.id)], new IscrizioneObj(result));

          //alert('Registrazione aggiornata correttamente ' + result.nome);

        } else {
          if (this.http && this.http != undefined) {
            const self = this;

            const url = environment.apiUrl + environment.subscription_route + '?progetto=' + this.progetto?.id;


            const transferObject = {
              "nome": nome,
              "cognome": cognome,
              "azienda": azienda,
              "email": email,
              "profilo": profilo
            }

            const header = new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${environment.sub_apy_key}`
            })

            const object = JSON.stringify(transferObject);

            //Here is the point!
            self.http?.post(url, object, { headers: header }).subscribe((response: any) => {
              if (response && response.message === 'fatto') {
                alert('Registrazione inviata correttamente');
                const _i = new IscrizioneObj(transferObject);
                this.iscritti?.push(_i);
              } else {
                alert('Problemi nella nuova iscrizione ' + ((response && response.message) ? response.message : ''));
              }
            });
          } else {
            console.error('Httpclient non disponibile!!!');
          }
        }
        this.closeModal();
      }

    } catch (error: any) {
      error = JSON.parse(JSON.stringify(error));
      console.error(error);
      this.print_error = error;
    }
  }
  /*EXCEL*/
  async generateExcel() {
    const self = this;

    let data: any[] = [];
    self.app.showSpinner();
    if (self.edizione) {
      const _filter = {
        "edizione": {
          "_eq": self.edizione.id
        }
      };

    const _iscritti = await directus
      .request<IscrizioneObj[]>(readItems("iscrizioni", {
        filter: _filter,
        limit: -1,
        fields: ["id", "status", "nome", "cognome", "azienda", "email", "edizione", "profilo", "edizione", "confermata", "presenza", "date_created", "date_updated"],
        sort: ['date_created'], //Sort by sort field and creation date descending
      }));
    _iscritti.forEach(async (_iscritto: IscrizioneObj) => {
      if (_iscritto && _iscritto != undefined) {
        let _ix = { Nome: _iscritto.nome.toUpperCase(), Cognome: _iscritto.cognome.toUpperCase(), Azienda: _iscritto.azienda.toUpperCase(), Email: _iscritto.email.toUpperCase(), Confermato: (_iscritto.confermata ? "SI" : "NO") };
        data.push(_ix);
      }
    });
    self.excelService.generateExcel(data, self.edizione.nome);
  }
          self.app.hideSpinner();
}
/*UTILITY*/
sanitizeInput(value: any) {
  const sanitizedValue = this.sanitizer.sanitize(
    SecurityContext.HTML,
    value
  );
  this.sanitizedValue = sanitizedValue ? sanitizedValue.toString() : '';
}
  /*
  MODALE
  */
  override openModal() {
  this.zone.run(async () => {
    this.setFormIscrizione();
    super.openModal();
  });
}
  override closeModal() {
  this.zone.run(async () => {
    this.iscritto = undefined;
    this.setFormIscrizione();
    super.closeModal();
  });
}
}
/**
 *
 * const printJobsItems = await directus.items('print_jobs').readMany({
            filter: {
                        id: { _in: salesOrder.print_production }
            }
});


const client = createDirectus('directus_project_url').with(rest());

const result = await client.request(createItem(collection_name, item_object));

 */
